<template>
   <main-content-layout title="Em Desenvolvimento...">
    <div style="height: 400px; color: #c1c1c1;" class="flex flex-center column">
      <q-icon name="mdi-hammer" size="190px"></q-icon>
      <h3 style="font-size: 20px; margin: 3px 20px">Em Desenvolvimento...</h3>
    </div>
   </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequestController from '../ServiceRequestController'
import MainContentLayout from './Layout/MainContentLayout.vue'

@Component({
  name: 'ServiceRequestBase',
  components: {
    MainContentLayout
  },
  props: {
  }
})
class ServiceRequestBase extends Vue {
  controller = ServiceRequestController.getInstance();
}
export default ServiceRequestBase
</script>
<style  scoped>

</style>
